import React, { useMemo } from 'react';
import './styles.css';
import ROUTE from '../../constants/route';
import {Role} from '../../helpers/user';
import PageLayout from '../../layouts/PageLayout';
import SetupEmailForm from '../../scenes/Form/components/SetupEmailForm';
import Sidebar from '../../scenes/Sidebar';
import InBoundsHistory from '../../scenes/Sidebar/components/InBoundsHistory';

export const TYPE = { PROCESS: 'process', PROJECT: 'project' };

const SetupEmail = props => {
  const {
    user,
    match: {
      params: { type, id },
    },
    history,
    pageTitle,
  } = props;

  const isRecruiter = useMemo(() => Role.isRecruiter(user), [user]);

  const handleClose = () => {
    history.push(
      TYPE.PROCESS === type
        ? ROUTE.SEARCH_PROCESS_MANAGE
        : ROUTE.SEARCH_PROJECT_MANAGE
    );
  };

  const handleInitError = () => {
    history.replace(ROUTE.ERROR_404);
  };

  return (
    <PageLayout
      pageClass="setup-email"
      pageTitle={pageTitle}
      mainContent={
        <SetupEmailForm
          type={type}
          id={id}
          onCloseForm={handleClose}
          onInitError={handleInitError}
        />
      }
      sidebarContent={
        <Sidebar>
          <InBoundsHistory isRecruiter={isRecruiter} />
        </Sidebar>
      }
    />
  );
};

export default SetupEmail;
